module.exports = __webpack_public_path__ + "img/deviceMoving.f2f5f074.svg";